// @ts-nocheck
import { observable, computed, action } from "mobx";

// Utils Stores
import { EInternalEvents } from "../InternalEventsStore/InternalEventsStore";

// Util
import { dynamicSortByProperty } from "../../utils/SortUtils/SortUtils";
import { didSearchList } from "../../utils/Utils";

class InformativeLogotypeStore {
  @observable dataList = [];
  @observable isFetching = false;
  @observable searchString = "";

  didChangeSelectedContractSubscriberKey = null;

  constructor(
    internalEventsStore,
    resourcesStore,
    notificationsStore,
    modboxAPIService,
    modboxFileService
  ) {
    this.resourcesStore = resourcesStore;
    this.notificationsStore = notificationsStore;
    this.modboxAPIService = modboxAPIService;
    this.modboxFileService = modboxFileService;

    internalEventsStore.subscribeTo({
      eventKey: EInternalEvents.didChangeSelectedContract,
      observer: this,
      callback: this.clearStore,
    });

    internalEventsStore.subscribeTo({
      eventKey: EInternalEvents.didLogout,
      observer: this,
      callback: this.clearStore,
    });
  }

  @action
  clearStore = () => {
    this.isFetching = false;
    this.dataList = [];
    this.searchString = "";
  };

  @action
  setIsFetching = (newValue) => {
    this.isFetching = newValue;
  };

  @action
  setDataList = (newValue) => {
    this.dataList = newValue;
  };

  @action
  setSearchString = (searchString) => {
    this.searchString = searchString;
  };

  @computed
  get filteredDataList() {
    if (this.searchString.length > 0) {
      return didSearchList(
        this.searchString,
        this.dataList,
        (logotype, textIncludesSearchString) =>
          textIncludesSearchString(logotype.label)
      );
    }

    return this.dataList;
  }

  @action
  getDataList = (withFetchingAnimation = true) => {
    this.setIsFetching(withFetchingAnimation);
    let newList = [];

    this.modboxAPIService
      .requestLogotypes()
      .then((response) => {
        if (response.status === 200) {
          response.data.logos.forEach((logotype) => {
            newList.push({
              label: logotype.label,
              ledArea: logotype.led_area,
              backgroundColor: `#${logotype["background_color"]}`,
              token: logotype["logo_token"],
              imageHash: logotype.image,
              imageUrl: logotype.url_img,
              isTransparent: logotype.transparent === "True",
              isVertical: logotype.orientation === "90",
            });
          });
        }

        this.setDataList(newList.sort(dynamicSortByProperty("label")));

        this.setIsFetching(false);
      })
      .catch((error) => {
        window.debugError("error in requestLogotypes", error);
        if (error && error.statusCode === 429) {
          setTimeout(this.getLogotypesList, 2000);
        }
      });
  };

  refreshResourcesStore = () => {
    this.resourcesStore.getResourceRulesList("logotype", false);
  };

  submit = (logotype) => {
    return new Promise((resolve, reject) => {
      this.modboxAPIService
        .submitLogotype(logotype)
        .then((response) => {
          this.notificationsStore.addSnackbarNotification({
            message: this.i18nStore.localizedString({
              id: "Schedule@readyToCreateRulesMessage",
              defaultString:
                "Configure uma regra para começar a utilizar o recurso.",
            }),
            color: "success",
          });
          this.getDataList(false);
          resolve(response);
        })
        .catch((error) => reject(error));
    });
  };

  update = (logotype) => {
    return new Promise((resolve, reject) => {
      this.modboxAPIService
        .updateLogotype(logotype)
        .then((response) => {
          this.notificationsStore.addSnackbarNotification({
            message: response.data.message,
            color: "success",
          });
          this.getDataList(false);
          this.refreshResourcesStore();
          resolve(response);
        })
        .catch((error) => reject(error));
    });
  };

  delete = (logotype) => {
    return new Promise((resolve, reject) => {
      this.modboxAPIService
        .deleteLogotype(logotype)
        .then((response) => {
          this.notificationsStore.addSnackbarNotification({
            message: response.data.message,
            color: "success",
          });
          this.getDataList(false);
          this.refreshResourcesStore();
          resolve(response);
        })
        .catch((error) => reject(error));
    });
  };

  getWithToken = (token) => {
    if (this.dataList.length > 0) {
      return this.dataList.find((group) => group.token === token);
    }
    return null;
  };
}

export default InformativeLogotypeStore;
